import input from '@/components/input'

/**
 * @module
 * @name InputCheckbox
 * @extends Input
 */
export default {
  name: 'InputCheckbox',
  /**
   * @property {Array} options Array of options. Option contain key and value.
   */
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  extends: input,
  methods: {
    /**
     * @function
     * @name handleCheckboxClick
     * @param {String} inputKey Option key
     * @description Handler for click. All the values are reviewed for setting
     *              each of them checked. Then, selectedValues are emitted to
     *              parent as an event.
     */
    handleCheckboxClick: function () {
      let selectedInput = this.$el.querySelectorAll('input[type="checkbox"]')
      const selectedValues = {}
      selectedInput.forEach(input => {
        selectedValues[input.value] = input.checked
      })
      this.$emit('change', selectedValues)
    },
    /**
     * @function
     * @name isChecked
     * @param {String} key Option key
     * @description Checks if a property exists in checkbox array.
     */
    isChecked: function (key) {
      return this.value[key]
    }
  }
}
